import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted } from 'vue';
export default {
  __name: 'App',
  setup(__props) {
    onMounted(() => {
      window.version = `MS Landing version: ${process.env.VUE_APP_VERSION}`;
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view);
    };
  }
};